<template>
  <div class="logWordChart-wrapper">
    <el-row type="flex" class="treeButton">
      <el-row class="mr-r15 fl-l">
        <div :span="12" class="fl-l">
          <div class="setting-addel">
            <el-button size="mini" @click="onZoom('zoomIn')"><i class="far fa-search-plus" style="font-size:14px;"></i></el-button>
            <el-button size="mini" @click="onZoom('zoomOut')"><i class="far fa-search-minus" style="font-size:14px;"></i></el-button>
          </div>
        </div>
        <div :span="12" class="fl-l"><el-button @click="onZoom('zoomInit')" style="margin-left: 2px"><i class="far fa-sync-alt"></i></el-button></div>
      </el-row>
      <el-row class="vertical-center-box mr-r15">
        <el-popover placement="bottom" width="500" trigger="hover" :offset="40">
          <span class="text"> - 메시지의 구조를 파악하는 기능입니다. <br/> - 키워드 맵은 <em>최근 2000개의 로그</em>를 기준으로 작성됩니다</span>
          <span slot="reference"><i class="fas fa-info-circle" style="cursor: pointer"></i></span>
        </el-popover>
    </el-row>
    </el-row>
    <div v-loading="loading" style="height:100%; width:100%;">
      <svg  ref="svg" class="svgclass" width="100%" height="100%"></svg>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LogAPI from '@/api/log/common';
import msgUtils from '@/utils/message';
import * as d3 from 'd3';
import { isNil } from 'lodash';

export default {
  name: 'WLogKeywordMap',
  data() {
    return {
      loading: false,
      readyFlag: true,
      nodes: [],
      links: [],
      link: {},
      node: {},
      chartData: {},
      textElements: {},
      graphLayout: {},
      wordChartData: [],
      wordArrayData: [],
      wordGroupData: {},
      adjlist: [],
      zoomHandler: null,
      zoom: {
        x: 0,
        y: 0,
        k: 1,
      },
      g: null,
    };
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: mapGetters(['analysisDateParams', 'selectedNode']),
  watch: {
    analysisDateParams() {
      if (this.active) {
        this.chartReset();
      }
    },
    selectedNode() {
      if (this.active) {
        this.chartReset();
      }
    },
    active: {
      handler(to) {
        if (to) {
          this.chartReset();
        } else {
          const svg = d3.select('.svgclass');
          svg.selectAll('*').remove();
        }
      },
    },
  },
  methods: {
    onZoom(zoomType) {
      const svg = d3.select('.svgclass');

      if (zoomType === 'zoomIn') {
        svg.transition().call(this.zoomHandler.scaleBy, 1.2);
      } else if (zoomType === 'zoomOut') {
        svg.transition().call(this.zoomHandler.scaleBy, 0.8);
      } else if (zoomType === 'zoomInit') {
        if (!isNil(this.zoomHandler)) {
          this.zoomHandler.transform(svg, d3.zoomIdentity);
        }
        svg.selectAll('*').remove();
        this.loadData();
      }
    },
    /**
     * 워드차트 설정 초기화
     * @author leesy918
     */
    chartReset() {
      this.wordChartData = [];
      this.wordArrayData = [];
      this.wordGroupData = {};
      this.zoom = {
        x: 0,
        y: 0,
        k: 1,
      };
      const svg = d3.select('.svgclass');
      if (!isNil(this.g)) {
        this.zoomHandler = d3.zoom().scaleExtent([0.5, 4]).on('zoom', () => {
          this.g.attr('transform', `translate(${this.zoom.x},${this.zoom.y})scale(${this.zoom.k})`);
        });
        this.zoomHandler.transform(svg, d3.zoomIdentity);
      }
      svg.selectAll('*').remove();
      if (!isNil(this.selectedNode.type)) {
        this.loadData();
      }
    },
    /**
     * 워드차트 데이터 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      const params = {};
      params.startDateTime = this.analysisDateParams.startDatetime;
      params.endDateTime = this.analysisDateParams.endDatetime;
      if (this.selectedNode.type !== 'root' && !this.selectedNode.leaf) {
        params.logType = this.selectedNode.type.toUpperCase();
      } else if (this.selectedNode.leaf && this.selectedNode.type !== 'user') {
        params.objId = this.selectedNode.objId;
        if (this.selectedNode.type === 'event') {
          params.filterId = this.selectedNode.filterId;
        } else {
          params.logType = this.selectedNode.type.toUpperCase();
        }
      } else {
        params.customFilterId = this.selectedNode.filterId;
      }

      this.loading = true;
      LogAPI.getWordChart(params).then((response) => {
        if (response.data.success) {
          this.wordChartData = response.data.data;
          this.creatWord();
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '키워드맵', false));
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '키워드맵', false));
        throw new Error(e);
      }).finally(() => {
        this.loading = false;
      });
    },
    flattern(data) {
      const nodes = [];
      data.size = this.recurse(data, nodes);
      return nodes;
    },
    recurse(node, nodes) {
      if (node.children) node.size = node.children.reduce((p, v) => p + this.recurse(v), 0);
      nodes.push(node);
      return node.size;
    },
    /**
     * 중복 데이터 제거
     * @author leesy918
     * @return {[type]} [description]
     */
    creatWord() {
      let count = 1;
      this.wordChartData.forEach((word) => {
        let checkWord = this.wordArrayData.find((item) => (item.name === word.name && item.group === word.group));
        if (checkWord) {
          checkWord.size += 1;
        } else {
          checkWord = {
            name: word.name,
            group: word.group,
            size: 1,
          };
          this.wordArrayData.push(checkWord);
        }
      });

      if (this.wordArrayData.length > 300) {
        this.wordArrayData.sort((a, b) => {
          if (a.size < b.size) {
            return 1;
          } else if (a.size > b.size) {
            return -1;
          }
          return 0;
        });
        this.wordArrayData.splice(300, this.wordArrayData.length);
      }
      this.wordArrayData.forEach((item) => {
        if (isNil(this.wordGroupData[item.group])) {
          this.wordGroupData[item.group] = count;
          count += 1;
        }
      });
      this.$emit('wordCount', this.wordArrayData);
      this.creatChartData();
    },
    /**
     * 차트 생성
     * @author leesy918
     * @return {[type]} [description]
     */
    creatChartData() {
      this.nodes = [];
      this.links = [];

      const groupData = Object.entries(this.wordGroupData);
      groupData.forEach((item) => {
        this.nodes.push({
          id: item[0],
          isLeaf: false,
          group: item[1],
        });
      });
      // node & link 데이터 설정
      this.wordArrayData.forEach((item) => {
        // 그룹 node가 있는가?
        let checkItem = this.nodes.find((node) => (item.group === node.groupName));
        if (!checkItem) {
          // 그룹 노드 없을때
          checkItem = this.nodes.find((node) => (item.name === node.id));
          if (!checkItem) {
            checkItem = {
              id: item.name,
              group: this.wordGroupData[item.group],
              size: item.size,
              isLeaf: true,
              groupName: item.group,
            };
            this.nodes.push(checkItem);
          }
        } else {
          // 그룹 노드 있을때
          checkItem = this.nodes.find((node) => (item.name === node.id));
          if (!checkItem) {
            checkItem = {
              id: item.name,
              size: item.size,
              isLeaf: true,
              group: this.wordGroupData[item.group],
            };
            this.nodes.push(checkItem);
          }
        }
        const link = {
          source: item.name,
          target: item.group,
        };
        if (!(link.source === link.target)) {
          this.links.push(link);
        }
      });

      this.chartData = {
        nodes: this.nodes,
        links: this.links,
      };
      this.updateChart();
    },
    updateChart() {
      // 그려줄 차트 설정
      const svg = d3.select('.svgclass');
      const color = d3.scaleOrdinal(d3.schemeCategory10);
      const svgWidth = svg.style('width');
      let width = Number(svgWidth.substring(0, svgWidth.length - 2));
      const svgHeight = svg.style('height');
      let height = Number(svgHeight.substring(0, svgHeight.length - 2));

      if (width <= 10 && height <= 10) {
        width = window.innerWidth - (window.innerWidth / 5);
        height = window.innerHeight - (window.innerHeight / 5);
      }
      const graph = this.chartData;
      const label = {
        nodes: [],
        links: [],
      };
      const container = svg.append('g');

      graph.nodes.forEach((d, i) => {
        label.nodes.push({ node: d });
        label.nodes.push({ node: d });
        label.links.push({
          source: i * 2,
          target: (i * 2) + 1,
        });
      });

      this.link = container.append('g').attr('class', 'links')
        .selectAll('line')
        .data(graph.links)
        .enter()
        .append('line')
        .attr('stroke', '#aaa')
        .attr('stroke-width', '1px');

      this.node = container.append('g').attr('class', 'nodes')
        .selectAll('g')
        .data(graph.nodes)
        .enter()
        .append('circle')
        .attr('r', (d) => {
          if (d.size < 10 || !d.isLeaf) {
            return 5;
          } else if (d.size < 100) {
            return 10;
          } else if (d.size < 1000) {
            return 15;
          }
          return 20;
        })
        .attr('fill', (d) => color(d.group));

      this.textElements = container.append('g').attr('class', 'text').selectAll('text')
        .data(graph.nodes)
        .enter()
        .append('text')
        .text((node) => node.id)
        .attr('font-size', 11)
        .attr('dx', 15)
        .attr('dy', 4);

      this.graphLayout = d3.forceSimulation(graph.nodes)
        .force('charge', d3.forceManyBody().strength(-1250))
        .force('center', d3.forceCenter(width / 2, height / 2))
        .force('x', d3.forceX(width / 2).strength(1))
        .force('y', d3.forceY(height / 2).strength(1))
        .force('link', d3.forceLink(graph.links).id((d) => d.id).distance(1).strength(1))
        .on('tick', () => {
          this.textElements
            .attr('x', (node) => node.x)
            .attr('y', (node) => node.y);
          this.node.call((node) => {
            node.attr('transform', (d) => `translate(${this.fixna(d.x)},${this.fixna(d.y)})`);
          });
          this.link.call((link) => {
            link.attr('x1', (d) => this.fixna(d.source.x))
              .attr('y1', (d) => this.fixna(d.source.y))
              .attr('x2', (d) => this.fixna(d.target.x))
              .attr('y2', (d) => this.fixna(d.target.y));
          });
        });

      this.adjlist = [];
      graph.links.forEach((d) => {
        this.adjlist[`${d.source.index}-${d.target.index}`] = true;
        this.adjlist[`${d.target.index}-${d.source.index}`] = true;
      });

      this.zoomHandler = d3.zoom()
        .scaleExtent([0.1, 4])
        .on('zoom', () => { container.attr('transform', d3.event.transform); });

      svg.call(this.zoomHandler);

      this.node.on('mouseover', () => {
        const index = d3.select(d3.event.target).datum().index;
        this.node.style('opacity', (o) => (this.neigh(index, o.index) ? 1 : 0.1));
        this.textElements.attr('display', (o) => (this.neigh(index, o.node.index) ? 'block' : 'none'));
        this.link.style('opacity', (o) => (o.source.index === index || o.target.index === index ? 1 : 0.1));
      }).on('mouseout', () => {
        this.textElements.attr('display', 'block');
        this.node.style('opacity', 1);
        this.link.style('opacity', 1);
      });
      this.node.call(
        d3.drag()
          .on('start', (d) => {
            d3.event.sourceEvent.stopPropagation();
            if (!d3.event.active) this.graphLayout.alphaTarget(0.3).restart();
            d.fx = d.x;
            d.fy = d.y;
          })
          .on('drag', (d) => {
            d.fx = d3.event.x;
            d.fy = d3.event.y;
          })
          .on('end', (d) => {
            if (!d3.event.active) this.graphLayout.alphaTarget(0);
            d.fx = null;
            d.fy = null;
          }),
      );
      this.node.on('mouseover', () => {
        const index = d3.select(d3.event.target).datum().index;
        this.node.style('opacity', (o) => (this.neigh(index, o.index) ? 1 : 0.1));
        this.textElements.attr('display', (o) => (this.neigh(index, o.index) ? 'block' : 'none'));
        this.link.style('opacity', (o) => (o.source.index === index || o.target.index === index ? 1 : 0.1));
      }).on('mouseout', () => {
        this.textElements.attr('display', 'block');
        this.node.style('opacity', 1);
        this.link.style('opacity', 1);
      });
    },
    neigh(a, b) {
      return a === b || this.adjlist[`${a}-${b}`];
    },
    fixna(x) {
      if (isFinite(x)) return x;
      return 0;
    },
  },
};
</script>

<style lang="scss">
.logWordChart-wrapper {
  height: 100%;
  background: #FFF;
.wordChart-node {
  stroke: #fff;
  stroke-width: 1.5px;
}

.wordChart-link {
  fill: none;
  stroke: #ccc;
}
.treeButton {
  position: absolute;
  top: 40px;
  left: 40px;
}

}
</style>



// WEBPACK FOOTER //
// src/views/log/components/analysis/LogWordChart.vue